
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { SchedulablePresenter, OutletPresenter } from 'shared/presenters';
import ActivityDetails from 'library/organisms/ActivityDetails/';
import ActivityConfig from 'library/organisms/ActivityConfig';
import ActivityRequestTimeSlot from 'library/organisms/ActivityRequestTimeSlot';
import CancellationPolicy from 'library/organisms/CancellationPolicy';
import ViewSwitch from 'shared/library/molecules/ViewSwitch';
import { Formik } from 'formik';
import generateInitialValuesForActivity from 'helpers/generateInitialValuesForActivity';
import useActivityPage from './useActivityPage';
import { Outlets, Schedulables } from 'shared/presenters/graphqlTypes';
import { useRouter } from 'next/router';
import GoogleStructuredDataEvent from './GoogleStructuredDataEvent';
import StructuredDataBreadcrumbForActivity from './StructuredDataBreadcrumbForActivity';
export interface ActivityProps {
    outlet: Partial<Outlets>;
    activity: Partial<Schedulables>;
}
const VIEWS = {
    details: {
        id: 'details',
        order: 0,
        channel: ['1', '2']
    },
    config: {
        id: 'config',
        order: 1,
        channel: ['1', '2']
    },
    requestTimeSlot: {
        id: 'requestTimeSlot',
        order: 2,
        channel: ['2']
    },
    cancellationPolicy: {
        id: 'cancellationPolicy',
        order: 2,
        channel: ['2']
    }
};
/**
 * Please think of this as a root page for the pages relating to configuring and making a booking
 *
 * The first page of the flow will be for displaying the details of the activity
 *
 * Other pages are to be hit via changing 'views'
 *
 * Note - we went with this view changing approach because we didn't want this driven by Url's via
 * Next.
 *
 */
const ActivityCore = ({ outlet: outletJSON, activity: activityJSON }: ActivityProps) => {
    const { outlet, activity, prices } = useActivityPage({
        outlet: outletJSON,
        activity: activityJSON
    });
    const data = {
        outlet,
        activity
    };
    return (<ViewSwitch views={VIEWS} viewSwitchId={'activity'}>
      {({ setView }) => (<>
          <ActivityDetails view={VIEWS.details.id} {...data} goToConfig={() => setView(VIEWS.config.id)} goToRequest={() => {
                setView(VIEWS.requestTimeSlot.id);
            }} goToCancellationPolicy={() => {
                setView(VIEWS.cancellationPolicy.id);
            }}/>
          <ActivityConfig view={VIEWS.config.id} {...data} {...prices} goToDetails={() => {
                setView(VIEWS.details.id);
            }} goToRequest={() => {
                setView(VIEWS.requestTimeSlot.id);
            }}/>
          <ActivityRequestTimeSlot view={VIEWS.requestTimeSlot.id} {...data} goToDetails={() => setView(VIEWS.details.id)}/>
          <CancellationPolicy view={VIEWS.cancellationPolicy.id} {...data} goToDetails={() => setView(VIEWS.details.id)}/>
        </>)}
    </ViewSwitch>);
};
const Activity = (props: ActivityProps) => {
    const { query } = useRouter();
    const activity = new SchedulablePresenter(props.activity);
    const outlet = new OutletPresenter(props.outlet);
    const categorySlug = query?.categorySlug as string;
    const widgetSlug = query?.widgetSlug as string;
    return (<>
      <GoogleStructuredDataEvent categorySlug={categorySlug} widgetSlug={widgetSlug} schedulable={activity} outlet={outlet}/>

      <StructuredDataBreadcrumbForActivity widgetSlug={widgetSlug} categorySlug={categorySlug} outlet={outlet} activity={activity}/>

      <Formik initialValues={generateInitialValuesForActivity(activity, query?.date as string | undefined)} 
    // Disable the next line because onSubmit is mandatory but we don't use it for this component.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSubmit={() => { }} enableReinitialize>
        <ActivityCore {...props}/>
      </Formik>
    </>);
};
export default Activity;

    async function __Next_Translate__getStaticProps__1966c8df4c2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Activity/Activity',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1966c8df4c2__ as getStaticProps }
  